(() => {
  const box = document.getElementById("xmas-snow-header");
  if (!box) return;

  const flakesCount = 45; // + grand = + neige visible

  const rand = (min, max) => Math.random() * (max - min) + min;

  for (let i = 0; i < flakesCount; i++) {
    const f = document.createElement("span");
    f.className = "flake";

    const size = rand(2, 6).toFixed(2) + "px";
    const left = rand(0, 100).toFixed(2) + "%";
    const dur = rand(2.8, 6.5).toFixed(2) + "s";
    const delay = rand(0, 4).toFixed(2) + "s";
    const drift = rand(-25, 25).toFixed(2) + "px";
    const op = rand(0.45, 1).toFixed(2);

    f.style.left = left;
    f.style.setProperty("--size", size);
    f.style.setProperty("--dur", dur);
    f.style.setProperty("--drift", drift);
    f.style.setProperty("--op", op);
    f.style.animationDelay = delay;

    box.appendChild(f);
  }
})();
